module.exports = __webpack_public_path__ + "assets/images/USDNEW50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW50.png
// module id = 1464
// module chunks = 1